// extracted by mini-css-extract-plugin
export var markdown = "_uc-0";
export var tableWrapper = "_uc-1";